import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useRef } from 'react';
import { useOnClickOutside } from '@ln/hooks';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const DrawerFooter = (_a) => {
    var { className, sticky } = _a, r = __rest(_a, ["className", "sticky"]);
    const _className = classNames(className, {
        'sticky bottom-0 z-2': sticky
    });
    return (jsx("div", Object.assign({ className: _className }, r)));
};

const DrawerBody = (_a) => {
    var { className } = _a, r = __rest(_a, ["className"]);
    const _className = classNames('drawer-body z-1 flex-grow-1 overflow-x-hidden', className);
    return (jsx("div", Object.assign({ className: _className }, r)));
};

const DrawerHeader = (_a) => {
    var { className, sticky } = _a, r = __rest(_a, ["className", "sticky"]);
    const _className = classNames('flex', className, {
        'sticky top-0 z-2': sticky
    });
    return (jsx("div", Object.assign({ className: _className }, r)));
};

function Drawer(_a) {
    var { className, position = 'left', handleClose, id, overlayClasses } = _a, r = __rest(_a, ["className", "position", "handleClose", "id", "overlayClasses"]);
    const drawerRef = useRef(null);
    const _className = classNames('drawer flex flex-column overflow-hidden fixed top-0 w-100 h-100vh h-100dvh', className, {
        'left-0': position === 'bottom',
        [`${position}-0`]: position,
    });
    const _overlayClassName = classNames('drawer-overlay fixed top-0 left-0 w-100 h-100vh visibility-hidden opacity-0', overlayClasses);
    const closeDrawer = () => {
        if (!drawerRef.current || drawerRef.current.dataset["visible"] !== "true")
            return;
        handleClose === null || handleClose === void 0 ? void 0 : handleClose();
    };
    useOnClickOutside(drawerRef, closeDrawer);
    return (jsx("div", Object.assign({ "data-id": `overlay-${id}`, className: _overlayClassName }, { children: jsx("div", Object.assign({ ref: drawerRef, className: _className, "data-id": id, "data-position": position, "data-visible": "false" }, r)) })));
}
Drawer.Header = DrawerHeader;
Drawer.Body = DrawerBody;
Drawer.Footer = DrawerFooter;

const toggleDrawer = ({ id, show }) => {
    if (typeof document === 'undefined')
        return;
    const drawer = document.querySelector(`[data-id=${id}]`);
    const overlay = document.querySelector(`[data-id=overlay-${id}]`);
    if (!drawer)
        return;
    if (show) {
        drawer.dataset['visible'] = 'true';
        overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove("visibility-hidden", "opacity-0");
        document.body.classList.add('overflow-hidden');
    }
    else {
        drawer.dataset['visible'] = 'false';
        overlay === null || overlay === void 0 ? void 0 : overlay.classList.add("visibility-hidden", "opacity-0");
        document.body.classList.remove('overflow-hidden');
    }
};

export { Drawer, toggleDrawer };
